import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Config } from '../models/config';

export abstract class RecaptchaService {
  abstract getNewRecaptchaToken(action: string): Observable<string>;
}

export class DummyRecaptchaService extends RecaptchaService {
  getNewRecaptchaToken(): Observable<string> {
    return from(Promise.resolve('123456'));
  }
}

export class GoogleRecaptchaService extends RecaptchaService {
  private recaptchaReady$: Observable<void>;

  constructor(private config: Config) {
    super();
    this.recaptchaReady$ = this.gRecaptchaReady();
  }

  public getNewRecaptchaToken(action: string): Observable<string> {
    return this.recaptchaReady$.pipe(switchMap(() => this.generateToken(this.config, action)));
  }

  private generateToken(config: Config, action: string): Observable<string> {
    return from(grecaptcha.execute(config.recaptcha_site_key, { action: action }));
  }

  private gRecaptchaReady(): Observable<void> {
    return new Observable<void>((subscriber) => {
      grecaptcha.ready(() => {
        subscriber.next();
      });
    });
  }
}
